import FlyerPrintTemplatePFJoinCode from './FlyerPrintTemplatePFJoinCode';
import FlyerPrintTemplatePFNoJoinCode from './FlyerPrintTemplatePFNoJoinCode';
import FlyerPrintTemplateWGJoinCode from './FlyerPrintTemplateWGJoinCode';
import FlyerPrintTemplateWGNoJoinCode from './FlyerPrintTemplateWGNoJoinCode';
import FlyerPrintTemplateSellPhotosJoinCode from './FlyerPrintTemplateSellPhotosJoinCode';
import FlyerPrintTemplateSellPhotosNoJoinCode from './FlyerPrintTemplateSellPhotosNoJoinCode';
import FlyerPrintTemplateSBJoinCode from './FlyerPrintTemplateSBJoinCode';
import FlyerPrintTemplateSBNoJoinCode from './FlyerPrintTemplateSBNoJoinCode';
import { isAlbumFolderForWebGalleryOnly } from '../../../../../../../../util/album-folder';
import { isHumanJoinCode } from '../../../../../../../../util/join-code';
import FlyerPrintTemplateNoWGJoinCode from './FlyerPrintTemplateNoWGJoinCode';
import FlyerPrintTemplateNoWGNoJoinCode from './FlyerPrintTemplateNoWGNoJoinCode';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';
import FlyerPrintTemplateMatchesWG from './FlyerPrintTemplateMatchesWG';

const templateConfiguration = [
  {
    name: 'SB Without Join Code',
    component: FlyerPrintTemplateSBNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.search_subscription_credits_joins_enabled,
  },
  {
    name: 'Matched photos + WG',
    component: FlyerPrintTemplateMatchesWG,
    when: albumFolder =>
      albumFolder.picture_day_enabled &&
      albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
      albumFolder.joins_enabled &&
      isHumanJoinCode(albumFolder.join_code),
  },
  {
    name: 'SB With Join Code',
    component: FlyerPrintTemplateSBJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.search_subscription_credits_joins_enabled,
  },
  {
    name: 'Sell Photos Without Join Code',
    component: FlyerPrintTemplateSellPhotosNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.picture_day_enabled,
  },
  {
    name: 'Sell Photos With Join Code',
    component: FlyerPrintTemplateSellPhotosJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && albumFolder.picture_day_enabled,
  },
  {
    name: 'WG Only Without Join Code',
    component: FlyerPrintTemplateWGNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) && albumFolder.is_web_gallery,
  },
  {
    name: 'WG Only With Join Code',
    component: FlyerPrintTemplateWGJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.is_web_gallery &&
      isAlbumFolderForWebGalleryOnly(albumFolder),
  },
  {
    name: 'Photo Finder With Join Code + Web Gallery',
    component: FlyerPrintTemplatePFJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && albumFolder.is_web_gallery,
  },
  {
    name: 'Photo Finder With Join Code, No Web Gallery',
    component: FlyerPrintTemplateNoWGJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && !albumFolder.is_web_gallery,
  },
  {
    name: 'Photo Finder Without Join Code, No Web Gallery',
    component: FlyerPrintTemplateNoWGNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) && !albumFolder.is_web_gallery,
  },
  {
    name: 'Default case (profile page)',
    component: FlyerPrintTemplatePFNoJoinCode,
    when: () => true,
  },
];

/**
 * Fetches the correct print template component to be used with the Flyer prints for marketing materials.
 *
 * @param {Object} options The options.
 * @param {Object} options.albumFolder The AlbumFolder.
 * @returns {{component: function({albumFolder: *}): *, name: string, when: function(*): *}|{component: function({albumFolder: *}): *, name: string, when: function(*): *}|null}
 */
export const getAccountMarketingMaterialFlyerPrintTemplateComponent = ({
  albumFolder,
}) => {
  const template =
    templateConfiguration.find(config => config.when(albumFolder)) ?? {};
  const { component } = template;
  return component ?? null;
};
